var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"myMinigame"}},[_c('div',{staticStyle:{"width":"100%","height":"calc(100vh - 60px)","padding-bottom":"80px"}},[_c('iframe',{attrs:{"frameborder":"0","src":_vm.gameBaseUrl,"width":"100%","height":"100%"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3705ce1e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/myPkFit/myMinigame.vue
// module id = null
// module chunks = 